import { Component, OnInit, Input, NgZone } from '@angular/core';
import { EventsService } from 'angular4-events';

@Component({
  selector: 'app-theme-loader',
  templateUrl: './theme-loader.component.html',
  styleUrls: ['./theme-loader.component.css']
})
export class ThemeLoaderComponent implements OnInit {

  @Input()
  displayProgress = false;

  constructor(private events: EventsService, private zone: NgZone, ) { }

  ngOnInit() {
    this.events.subscribe('updateProgress', () => {
      this.zone.run(() => {
        this.displayProgress = true;
      });
    });
    this.events.subscribe('hideAppLoader', () => {
      this.zone.run(() => {
        this.displayProgress = false;
      });
    });
  }

}
